import React from "react";
import {
    Popover,
    Grid,
    Typography,
    TextField,
    InputAdornment,
    Button,
    Alert,
    Collapse,
    FormControlLabel,
    Checkbox,
    FormControl,
    FormLabel,
    RadioGroup,
    FormHelperText,
    FormGroup,
    Radio,
    Tooltip,
    IconButton,
    Snackbar,
    useTheme,
    Box
} from "@mui/material";
import { copyToClipboard } from "../_helpers/copyToClipboardHelper";
import { ContentCopy } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import ConfirmBox from "./ConfirmBox";

const RepairRequestCompleteTaskPopover = ({
    open,
    anchorEl,
    onClose,
    handleType,
    textWarning,
    textBoxLabel,
    textBoxValue,
    notesToEdit,
    onTextBoxChange,
    onNotesChange,
    from = "repairRequestDetails",
    isNotify,
    onNotifyChange,
    toEmail,
    onToEmailChange,
    ccEmails,
    onCcEmailChange,
    emailModel = [],
    onSubmit,
    repairRequest,
}) => {
    const classes = useStyles();
    const { t } = useTranslation()
    const theme = useTheme()
    const [isOpenConfirmBox, setIsOpenConfirmBox] = useState({
        open: false,
        for: undefined
    })
    const [toast, setToast] = useState({
        open: false,
        message: "",
        type: "error"
    })
    const handleCancel = () => {
        setIsOpenConfirmBox({ open: false, for: undefined })
    }
    const getCopyTextComponent = ({ clipBoardValue = "", toastValue = "" }) => {
        return (
            <Tooltip title={t("general.copy")}>
                <IconButton
                    color="inherit"
                    aria-label="copy"
                    size="small"
                    onClick={() => {
                        copyToClipboard(clipBoardValue).then(() => {
                            setToast({
                                open: true,
                                message: t("general.copiedText", { text: toastValue || clipBoardValue }),
                                type: "success",
                            });
                        });
                    }}
                >
                    <ContentCopy htmlColor={theme.palette.action.active} />
                </IconButton>
            </Tooltip>
        );
    };
    return (
        <>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                id={"handleRepairRequestPopup"}
            >
                <div style={{ padding: "16px" }}>
                    <Grid container spacing={1} direction="column">
                        <Grid>
                            <Alert className={classes.alert} severity="warning">
                                {textWarning}
                            </Alert>
                        </Grid>
                        <Grid>
                            <Typography variant="h6">
                                {t("repairRequest.button." + handleType)}
                            </Typography>
                        </Grid>
                        <Grid>
                            <TextField
                                label={textBoxLabel}
                                value={textBoxValue}
                                onChange={onTextBoxChange}
                                margin="dense"
                                variant="outlined"
                                multiline
                                rows={10}
                                fullWidth
                                autoFocus
                                error={!textBoxValue || textBoxValue.trim() === ""}
                                disabled={repairRequest?.completed}
                                slotProps={{
                                    input: {
                                        endAdornment: textBoxValue && (
                                            <InputAdornment position="end">
                                                {textBoxValue && getCopyTextComponent({ toastValue: textBoxLabel, clipBoardValue: textBoxValue })}
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                        </Grid>
                        <Grid>
                            <TextField
                                label={t("repairRequest.internalNotes")}
                                className={classes.textField}
                                value={notesToEdit}
                                onChange={onNotesChange}
                                margin="dense"
                                variant="outlined"
                                multiline
                                rows={10}
                                fullWidth
                                error={!notesToEdit || notesToEdit.trim() === ""}
                                slotProps={{
                                    input: {
                                        endAdornment: notesToEdit && (
                                            <InputAdornment position="end">
                                                {notesToEdit && getCopyTextComponent({ toastValue: t("repairRequest.internalNotes"), clipBoardValue: notesToEdit })}
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                        </Grid>

                        {from === 'repairRequestDetails' && (
                            <>
                                <Grid>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isNotify}
                                                onChange={onNotifyChange}
                                                name="notify"
                                                color="primary"
                                            />
                                        }
                                        label={t("workOrders.notifyNow")}
                                    />
                                </Grid>

                                <Collapse in={isNotify} timeout="auto" unmountOnExit>
                                    <Grid>
                                        <FormControl component="fieldset" className={classes.formControlCheckList} required error={!toEmail || toEmail.trim() === ""}>
                                            <FormLabel component="legend">{t("general.email.to")}</FormLabel>
                                            {(!toEmail || toEmail.trim() === "") && <FormHelperText>{t("workOrders.noEmailKnown")}</FormHelperText>}
                                            <RadioGroup
                                                aria-label="toEmail"
                                                name="toEmail"
                                                value={toEmail}
                                                onChange={onToEmailChange}
                                            >
                                                {emailModel &&
                                                    emailModel
                                                        .filter((x) => x.emails && x.emails.length > 0 && x.key !== "resolver")
                                                        .map((item, index) => (
                                                            <FormControlLabel
                                                                key={index}
                                                                value={item.key}
                                                                control={<Radio />}
                                                                label={
                                                                    <>
                                                                        {item.title}
                                                                        {toEmail === item.key && (
                                                                            <>
                                                                                {item.emails &&
                                                                                    item.emails.map((email, index1) => (
                                                                                        <React.Fragment key={index1}>
                                                                                            <br />
                                                                                            <Typography variant="caption">{email}</Typography>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                }
                                                            />
                                                        ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid>
                                        <FormControl component="fieldset" className={classes.formControlCheckList}>
                                            <FormLabel component="legend">{t("general.email.cc")}</FormLabel>
                                            <FormGroup>
                                                {emailModel &&
                                                    emailModel
                                                        .filter((x) => x.key !== toEmail && x.emails && x.emails.length > 0)
                                                        .map((item, index) => (
                                                            <FormControlLabel
                                                                key={index}
                                                                control={
                                                                    <Checkbox
                                                                        checked={ccEmails.includes(item.key)}
                                                                        color="primary"
                                                                        onChange={(e) =>
                                                                            onCcEmailChange(e, item.key)
                                                                        }
                                                                        name={"cc-" + item.key}
                                                                    />
                                                                }
                                                                label={
                                                                    <>
                                                                        {item.title}
                                                                        {ccEmails.includes(item.key) && (
                                                                            <>
                                                                                {item.emails &&
                                                                                    item.emails.map((email, index1) => (
                                                                                        <React.Fragment key={index1}>
                                                                                            <br />
                                                                                            <Typography variant="caption">{email}</Typography>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                }
                                                            />
                                                        ))}
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                </Collapse>
                            </>
                        )}

                        <Grid>
                            <Grid container spacing={1} justifyContent="flex-end">
                                <Grid item>
                                    <Button variant="outlined" onClick={onClose}>
                                        {t("general.cancel")}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            if (from === 'repairRequestDetails') {
                                                onSubmit();
                                            } else {
                                                setIsOpenConfirmBox({ open: true, for: "submit" });

                                            }
                                        }}
                                        disabled={(isNotify === true && (!toEmail || toEmail.trim() === "")) || !textBoxValue || textBoxValue.trim() === ""}
                                    >
                                        {t("repairRequest.button." + handleType)}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Popover>
            <Snackbar
                open={toast?.open}
                autoHideDuration={6000}
                onClose={() =>
                    setToast({
                        open: false,
                        message: "",
                        type: "error"
                    })
                }
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                key={toast.message}
                sx={{ zIndex: 2000 }}
            >
                <Alert
                    onClose={() =>
                        setToast({
                            open: false,
                            message: "",
                            type: "error"
                        })
                    }
                    severity={toast?.type}
                >
                    {toast?.message}
                </Alert>
            </Snackbar>
            <ConfirmBox open={isOpenConfirmBox.open} title={t("general.warning")} description={<>
                <Box>
                    <Typography variant="body1" gutterBottom>
                        {t('repairRequest.task.completeWarning.part1')}
                    </Typography>
                    <Typography variant="body1" fontWeight={'bold'} >
                        {t('repairRequest.task.completeWarning.part2')}
                    </Typography>
                </Box>
            </>} okText={t("general.confirm")} cancelText={t("general.cancel")} onOk={async () => {
                await onSubmit()
                handleCancel()
            }}
                onCancel={handleCancel} />

        </>
    );

};
const useStyles = makeStyles((theme) => ({
    alert: {
        width: 350,
    },
    textField: {
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up("xs")]: {
            width: 350,
            maxWidth: "100%",
        },
    },
    formControlCheckList: {
        paddingLeft: theme.spacing(0.5),
        "& .MuiTypography-body1": {
            lineHeight: 1,
        },
    },
}));
export default RepairRequestCompleteTaskPopover;
